<template>
  <div class="panel panel-default">
    <div class="panel-body">
      <p class="admin-page-description">
        Recebedores de pagamento da instituição: contas bancárias,
        percentuais de split e dias de transferência. Aqui você gerencia
        quem recebe o repasse dos pagamentos dos alunos e em qual
        frequência.
      </p>
      <transfer-days v-if="transferDaysLoaded" />
      <recipients-list v-if="recipientsListLoaded" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TransferDays from './TransferDays';
import RecipientsList from './RecipientsList';

export default {
  components: {
    TransferDays,
    RecipientsList,
  },

  computed: {
    ...mapState([
      'institution',
    ]),
  },

  created() {
    this.$loader.show();

    this.loadTransferDays(this.institution.id)
      .then(() => {
        this.transferDaysLoaded = true;
      })
      .catch(() => {
        this.transferDaysLoaded = false;
        this.$alert.notifyAlert('Erro ao carregar dias de transferência, tente novamente mais tarde');
      })
      .finally(() => {
        this.$loader.hide();
      });

    this.loadRecipients(this.institution.id)
      .then(() => {
        this.recipientsListLoaded = true;
      })
      .catch(() => {
        this.recipientsListLoaded = false;
        this.$alert.notifyAlert('Erro ao carregar recebedores, tente novamente mais tarde');
      })
      .finally(() => {
        this.$loader.hide();
      });
  },

  data() {
    return {
      transferDaysLoaded: false,
      recipientsListLoaded: false,
    };
  },

  methods: {
    ...mapActions([
      'loadTransferDays',
      'loadRecipients',
    ]),
  },
};
</script>
